import { useGlobalModalsContext } from 'contexts/globalModalsContext';

import TrackedMenuItem from '../TrackedMenuItem';

const BrowseTemplatesMenuItem: React.FC = () => {
  const { openBrowseTemplatesModal } = useGlobalModalsContext();
  return (
    <TrackedMenuItem
      value="browse-templates"
      onClick={openBrowseTemplatesModal}
    >
      Browse templates
    </TrackedMenuItem>
  );
};

export default BrowseTemplatesMenuItem;
